import React from 'react';
import useScrollToTop from '../components/useScrollToTop';
import Button from '../components/Button';
import './floorpages.css';
import villageHomePlan1 from '../img/room_img_1.avif'; // Replace with relevant image
import courtyardHouseBihar from '../img/room_img_2.avif'; // Replace with relevant image
import ruralArchitecturePatna from '../img/room_img_4.avif'; // Replace with relevant image

const PageVillageHomeNaksha = () => {
  useScrollToTop();

  return (
    <div className='project-container'>
    <div className="project-details">
      <h1 className="">Traditional Village Home Plans in Patna: Rooted in Community & Culture</h1>

      <section className="">
        <h2 className="">Embracing the Essence of Rural Living in Bihar</h2>
        <p className="">
          Discover the charm and functionality of traditional village home plans tailored for Patna and the rural landscape of Bihar. Our collection embraces the essence of community living, incorporating spacious courtyards ('aangan'), natural ventilation, and designs that resonate with the local culture and climate of Bihar.
        </p>
      </section>

      <section className="">
        <h2 className="">Key Features of Our Village Home Nakshas for Bihar</h2>
        <ul className="list-items">
          <li>
            <strong>Spacious Courtyards (Aangan):</strong> Central open areas for family gatherings, natural light, and ventilation, a hallmark of traditional homes in Bihar.
            <img src={courtyardHouseBihar} alt="Courtyard House Plan in Bihar" className="project-image" />
          </li>
          <li>
            <strong>Use of Local Materials:</strong> Designs that often consider and incorporate locally available and sustainable building materials prevalent in rural Bihar.
          </li>
          <li>
            <strong>Accommodation for Extended Families:</strong> Layouts that can comfortably house multiple generations, reflecting the strong family ties in Bihar.
          </li>
          <li>
            <strong>Integration with the Landscape:</strong> Designs that harmonize with the surrounding rural environment of Patna and Bihar.
            <img src={ruralArchitecturePatna} alt="Rural Architecture in Patna, Bihar" className="project-image" />
          </li>
          <li>
            <strong>Natural Ventilation and Lighting:</strong> Architectural elements designed to maximize airflow and natural light, crucial for the climate of Bihar.
          </li>
        </ul>
      </section>

      <section className="">
        <h2 className="">Explore Our Collection of Village Home Plans for Patna</h2>
        <ul className="list-items">
          <li>Diverse layouts catering to different family sizes and needs in rural Bihar.</li>
          <li>Traditional architectural styles with regional influences.</li>
          <li>Options for incorporating modern amenities while retaining the traditional charm.</li>
          <li>Consideration for livestock and agricultural needs (where applicable).</li>
          <li>Adaptable designs that respect local customs and traditions.</li>
          <li>Plans optimized for the climate of Patna and Bihar.</li>
          <li>Cost-effective designs utilizing local building practices.</li>
        </ul>
      </section>

      <section className="">
        <h2 className="">Detailed AutoCAD 2D Drawings for Your Village Home in Bihar</h2>
        <p className="project-intro-text">
          Our detailed AutoCAD 2D drawings provide clear and precise blueprints for constructing your traditional village home in Bihar, ensuring accurate execution and adherence to your vision.
          <img src={villageHomePlan1} alt="Traditional Village Home Plan for Bihar" className="project-image" />
        </p>
        <ul className="list-items">
          <li>Clear floor plans with accurate dimensions of all rooms and spaces.</li>
          <li>Detailed layouts of courtyards and other traditional elements.</li>
          <li>Placement of doors, windows, and ventilation systems optimized for the local climate.</li>
          <li>Structural details relevant to local building practices in Bihar.</li>
        </ul>
      </section>
       <div className="">
          <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
            <Button className="button-outlined">वास्तु शास्त्र के अनुसार घर का डिज़ाइन बनवाने के लिए हमसे संपर्क करें!</Button>
          </a>
        </div>
    </div>
    </div>
  );
};

export default PageVillageHomeNaksha;